<div *ngIf="options?.length > 0 && hasHelperBtns" class="multiselect-tools">
    <button hc-button size="sm" buttonStyle="link-inline" (click)="selectAll()">Select All</button>
    <button hc-button size="sm" buttonStyle="link-inline" (click)="clearAll()">Clear All</button>
</div>
<hc-search-bar
    placeholder="Search apps..."
    [autoSearch]="true"
    [tight]="true"
    (triggerSearch)="search($event)"
></hc-search-bar>
<ul *ngIf="options?.length > 0" class="multiselect-options" [class.zebra-stripes]="useZebraStripes">
    <li *ngFor="let option of filteredOptions; let idx = index">
        <label [attr.for]="idx" class="popover-check" (keyup.enter)="optionClicked(option)">
            <hc-checkbox
                [tight]="true"
                id="{{ idx }}"
                name="configOption"
                [value]="option.id"
                (change)="optionClicked(option)"
                (blur)="onTouch()"
                [checked]="optionIsSelected(option)"
            >
                <ng-container
                    *ngTemplateOutlet="
                        _optionTemplate || defaultOptionTemplate;
                        context: { option: option, searchTerm: searchTerm }
                    "
                >
                </ng-container>
            </hc-checkbox>
        </label>
    </li>
</ul>

<ng-template #defaultOptionTemplate let-option="option" let-searchTerm="searchTerm">
    <span [innerHTML]="option?.label | highlight: searchTerm"></span>
</ng-template>

<div *ngIf="hasCancelBtn || hasConfirmBtn" class="checkbox-multiselect-footer">
    <button *ngIf="hasCancelBtn" hc-button buttonStyle="link-inline" size="sm" (click)="cancelClicked()">Cancel</button>
    <button
        *ngIf="hasConfirmBtn"
        class="confirm-btn"
        hc-button
        buttonStyle="primary"
        size="sm"
        (click)="confirmClicked()"
    >
        Add selected ({{ model.length }})
    </button>
</div>
